import React from 'react';
const Background = () => {
    return (
        <div className="wallpaper"></div>
    );
};

export default Background;